export enum ProjectTemplateTypes {
  ShareHolderMeeting = 1,
  CorporateAction = 2
}

export enum ProjectTemplateTypesAsString {
  ShareHolderMeeting = 'shareholder meeting',
  CorporateAction = 'corporate action'
}
